/* eslint-disable max-len */
import {AutoMobileQuestions} from '../../../../../components/Forms/Constants/TCFD/AutoMobile/autoMobileQuestions';
import {inputType} from '../../../interface/inputType';

export const GovernanceTabQuestions = [
  {
    key: AutoMobileQuestions.QUESTION_GROUP_1.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_1.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1.Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  },
  {
    key: AutoMobileQuestions.QUESTION_GROUP_2.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_2.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4_DISPLAY
                .Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_4_COMMENT
                .fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_5_COMMENT
                .fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_6_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_7_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  }
];

export const StrategyTabQuestions = [
  {
    key: AutoMobileQuestions.QUESTION_GROUP_3.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_3.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1.Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2_DISPLAY
                .Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_4_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  },
  {
    key: AutoMobileQuestions.QUESTION_GROUP_4.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_4.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1.Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3.Question
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_4_DISPLAY
                .Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_4.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_4
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_4.Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_5.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_5
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_5
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_5
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_5.Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_6.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_6
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_6
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_6
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_6.Question
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_7.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_7
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_7
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_7
                .fieldLabel
          }
        ]
      }
    ]
  },
  {
    key: AutoMobileQuestions.QUESTION_GROUP_5.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_5.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_3
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_4_DISPLAY
                .Question
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_4.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_4
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_4.Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_5.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_5
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_5
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_5
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_5.Question
          },
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_6.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_6
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_6
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_6
                .fieldLabel,
            Question:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_6.Question
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7_DISPLAY
                .Question
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_7_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_8_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_9_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  }
];

export const RiskManagementTabQuestions = [
  {
    key: AutoMobileQuestions.QUESTION_GROUP_6.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_6.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3
                .fieldLabel
          }
        ]
      }
    ]
  },
  {
    key: AutoMobileQuestions.QUESTION_GROUP_7.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_7.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4_DISPLAY
                .Question
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_4_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_5_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_6_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  },
  {
    key: AutoMobileQuestions.QUESTION_GROUP_8.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_8.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_4
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_4_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_4_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_4_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5_DISPLAY
                .Question
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_5_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_6_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7.Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_7_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  }
];

export const MetricsTargetsTabQuestions = [
  {
    key: AutoMobileQuestions.QUESTION_GROUP_9.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_9.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_4
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_4_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_4_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_4_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5.Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5.options
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_5_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  },
  {
    key: AutoMobileQuestions.QUESTION_GROUP_10.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_10.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1.Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldLabel,
            options:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .options,
            fieldsListOnTriggerYes:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldsListOnTriggerYes,
            fieldsOnTriggerNo:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldsOnTriggerNo
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2_DISPLAY
                .Question
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_4
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_4_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_4_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_4_COMMENT
                .fieldLabel
          }
        ]
      }
    ]
  },
  {
    key: AutoMobileQuestions.QUESTION_GROUP_11.KEY,
    label: AutoMobileQuestions.QUESTION_GROUP_11.NAME,
    kpiId: '',
    items: [
      {
        question:
          AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1_DISPLAY
            .Question,
        field: [
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_4
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_4
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_4
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_4_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_4_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_4_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_5_DISPLAY
                .Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_5
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_5
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_5
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_5_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_5_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_5_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_6
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_6
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_6
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_6_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_6_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_6_COMMENT
                .fieldLabel
          },

          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_7
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_7
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_7
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_7_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_7_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_7_COMMENT
                .fieldLabel
          },

          {
            fieldType: inputType.HEADING,
            heading:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_8_DISPLAY
                .Question
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_8
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_8
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_8
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_8_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_8_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_8_COMMENT
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_9
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_9
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_9
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_9_COMMENT
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_9_COMMENT
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_9_COMMENT
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_10
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_10
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_10
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS
                .QUESTION_10_COMMENT.fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS
                .QUESTION_10_COMMENT.fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS
                .QUESTION_10_COMMENT.fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_11
                .fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_11
                .fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_11
                .fieldLabel
          },
          {
            fieldType:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS
                .QUESTION_11_COMMENT.fieldType,
            fieldName:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS
                .QUESTION_11_COMMENT.fieldName,
            fieldLabel:
              AutoMobileQuestions.QUESTION_GROUP_11.QUESTIONS
                .QUESTION_11_COMMENT.fieldLabel
          }
        ]
      }
    ]
  }
];
